/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {RoleGrants} from '../models/RoleGrants';

export interface GetRoleGrants$Request {
    roleId: string;
    pageNumber: number;
    pageSize: number;
}

export interface GetRoleGrants$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getRoleGrantsRequest = createAction<PayloadData<void, GetRoleGrants$Request>>('ROLE_GRANTS__GET_ROLE_GRANTS__REQUEST');
export const getRoleGrantsSuccess = createAction<PayloadData<RoleGrants, GetRoleGrants$Request>>('ROLE_GRANTS__GET_ROLE_GRANTS__SUCCESS');
export const getRoleGrantsFailure = createAction<PayloadData<Error, GetRoleGrants$Request, true>>('ROLE_GRANTS__GET_ROLE_GRANTS__FAILURE');

export const getRoleGrantsActions = [
    getRoleGrantsRequest,
    getRoleGrantsSuccess,
    getRoleGrantsFailure
] as const;

/**
 * @param {string} meta.roleId
 * @param {number} meta.pageNumber
 * @param {number} meta.pageSize
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getRoleGrants = (meta: GetRoleGrants$Request, config?: GetRoleGrants$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
    };
    return {
        CALL_API: {
            types: getRoleGrantsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/entitlements/roles/${meta.roleId}/grants`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

